import { QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
import queryClient from "QueryClient/queryClient";
import { ErrorBoundary } from "Components/ErrorBoundary/ErrorBoundary";
import { ConfigProvider, Layout } from "antd";
import { RouterWrapper } from "Features/Routes/RouterWrapper";
import { useAxiosSetup } from "QueryClient/axiosClient";
import { useUserInfo } from "GlobalStates/User";
import { useEffect, useState } from "react";
import { Sidebar } from "Features/Sidebar/Sidebar";
import { Navbar } from "Features/Navbar/Navbar";
import { useLocation } from "react-router-dom";
import { ROUTES } from "Constants/AllRoutes";

const { Content } = Layout;
function App() {
  useAxiosSetup();
  const { user } = useUserInfo();
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const contentContainer = document.getElementById("content-container");
    if (contentContainer) {
      contentContainer.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      setIsScrolled(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    const contentContainer = document.getElementById("content-container");
    if (contentContainer) {
      contentContainer.addEventListener("scroll", () => {
        setIsScrolled(contentContainer.scrollTop > 0);
      });
    }
  }, []);

  const [collapsed, setCollapsed] = useState(false);
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <div className="App">
          <ErrorBoundary>
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: "#80e280",
                  colorBgContainer: "#ffffff",
                  colorBgBase: "#ffffff",
                },
                components: {
                  Input: { controlHeight: 40, fontSize: 18 },
                  Select: { controlHeight: 40, fontSize: 18 },
                  Form: {
                    labelFontSize: 18, // Increase label font size
                    fontSize: 18, // Increase input font size
                  },
                },
              }}
            >
              <Layout
                hasSider={user?.token && user?.hasCompletedProfile}
                style={{
                  overflow: "initial",
                  width: "100%",
                  height: "100vh",
                  backgroundColor: "#ffffff",
                }}
              >
                {user?.token && user?.hasCompletedProfile && (
                  <Sidebar collapsed={collapsed} />
                )}
                <Layout
                  style={{
                    backgroundColor: "#ffffff",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  {!(
                    location.pathname.startsWith(ROUTES.REGISTER_ROLE) ||
                    location.pathname.startsWith(ROUTES.LINKEDIN_CALLBACK)
                  ) && (
                    <Navbar
                      collapsed={collapsed}
                      setCollapsed={setCollapsed}
                      isScrolled={isScrolled}
                    />
                  )}
                  <Content
                    id="content-container"
                    style={{
                      backgroundColor: "#ffffff",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <RouterWrapper />
                  </Content>
                </Layout>
              </Layout>
            </ConfigProvider>
          </ErrorBoundary>
        </div>
      </QueryClientProvider>
    </>
  );
}

export default App;
